import { selectBasketIsEmpty } from 'containers/OrderDetails/basketSlice'
import { getOrderRedirectPath } from 'utils/redirect'
import { useHistory } from 'react-router-dom'
import { useReduxSelector } from 'store'
import { useEffect } from 'react'

const useOrderRedirect = () => {
  const isBasketEmpty = useReduxSelector(selectBasketIsEmpty)
  const { replace } = useHistory()

  useEffect(() => {
    if (isBasketEmpty) {
      replace(getOrderRedirectPath())
    }
    // We need this only on startup!
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [replace])
}

export default useOrderRedirect